function SvgComponent({ ...props }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.9043 10.3616C17.9043 10.3616 16.6525 10.7302 15.455 12.7465C14.2575 14.7628 14.3985 15.3753 15.9449 17.9932M17.9043 10.3616L18.3942 6.07032C18.3942 6.07032 19.174 5.11638 19.8638 5.11638C20.5535 5.11638 21.3334 6.07032 21.3334 6.07032V17.5176C20.2029 19.2846 19.3577 20.0786 17.4145 21.3334H13.0057L2.71862 11.794C2.53034 10.5782 2.81735 10.2337 4.18817 10.3616L8.1071 14.1788L9.08682 13.2249L2.71862 7.02425C2.60447 6.53985 2.85937 5.68982 3.69834 6.07032L10.5564 12.2709L11.5361 11.317L5.16787 5.11357C4.67804 4.16103 5.1679 3.68406 6.14762 3.68406L13.0057 9.88607L13.9854 8.93213L8.59696 3.68547C8.39245 2.68318 8.7029 2.55922 9.57668 2.73153L17.9043 10.3616ZM3.20845 14.6543C3.38951 16.3397 4.01409 17.058 6.14762 17.5161"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default SvgComponent;
